import CustomContentCollectionTemplate from './custom-content-collection';
import CustomModalTemplate from './custom-modal';
import CustomTextTemplate from './custom-text';

export default {
  'custom-content-collection': CustomContentCollectionTemplate,
  'custom-modal': CustomModalTemplate,
  'custom-text': CustomTextTemplate,
};
